import styled from 'styled-components';

export const CenteredContent = styled.div`
    margin: 0 auto;
    min-width: 500px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const MainInputWrapper = styled.div`
    margin: 0 10px 10px 0;
    display: flex;
`;

export const MainLabel = styled.div`
    .title {
        font-size: 16px;
        color: ${({theme}) => theme.color_grey__600};
    }

    .subtitle {
        font-size: 12px;
        color: ${({theme}) => theme.color_grey__500};
    }

    .title,
    .subtitle {
        padding: 0 40px 0 0;
        font-weight: 500;
    }

    .pi {
        margin: 2px 10px 0 0;
        font-size: 16px;
    }
`;

export const AtriaTitle = styled.h1`
    font-size: 28px;
    color: rgb(0, 0, 0);
    margin-bottom: 20px;
`;

export const InlineRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
`;